import { useAppSelector } from "../../../app/store/store";
import { FEATURES, hasFeature, useMyActions } from "../../../entities/my";
import { useGlobalLoadingActions } from "../../../entities/globalLoading";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { MyError } from "../../../shared/lib/error/MyError";

export const useTeamsCommon = () => {
    const {my} = useAppSelector(s => s.myReducer)
    const {setIsAuth} = useMyActions()
    const {setIsLoading: setGlobalLoading} = useGlobalLoadingActions()
    const {setGlobalMessage} = useGlobalMessageActions()

    const canRead = hasFeature(my, FEATURES.TEAMS.READ) || hasFeature(my, FEATURES.TEAMS.MANAGE)
    const canManage = hasFeature(my, FEATURES.TEAMS.MANAGE)
    const canListWorkTgs = hasFeature(my, FEATURES.WORK_TGS.LIST)
    const canListCoordinators = hasFeature(my, FEATURES.IDM.STAFF_AVAILABLE_COORDINATORS)
    const canListCurators = hasFeature(my, FEATURES.IDM.STAFF_AVAILABLE_CURATORS)
    const canUseTeamForm = canManage && canListWorkTgs && canListCoordinators && canListCurators

    const handleError = (e: unknown, defaultMessage: string) => {
        console.log(e)
        if(e instanceof AuthError){
            setIsAuth(false)
            setGlobalMessage({message: e.message, type: 'error'})
            return
        }
        if(e instanceof MyError){
            setGlobalMessage({message: e.message || defaultMessage, type: 'error'})
            return
        }

        setGlobalMessage({message: defaultMessage, type: 'error'})
    }

    return {
        my,
        canRead,
        canManage,
        canListWorkTgs,
        canUseTeamForm,
        setGlobalLoading,
        setGlobalMessage,
        handleError,
    }
}
